export default __webpack_public_path__ + "static/theatreDrapeTop-e16bbeb16b9446af44bf12e36a18a274.svg";